/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import { DocumentTitle } from '../../components/DocumentTitle/DocumentTitle'
import { Button, Loading, Tag, Text, Tooltip } from '@sede-enterprise/shell-ds-react-framework'
import { Filter, Play } from '@sede-enterprise/shell-ds-react-framework/build/esm/components/Icon/components'
import FilterModal from '../../components/FilterModal/FilterModal'
import DataTable from '../../components/DataTable/DataTable'
import useGetModelList from './hooks/useGetModelList'
import { splitToArray } from '../../util/helperFunctions'
import { modelStatusSentimentMap } from '../../util/constants'
import { useHistory } from 'react-router-dom/cjs/react-router-dom'
import useLogReport from '../../util/hooks/useLogReport'


const INIT_PAGE = 1;
const INIT_ORDER = "train_start_ts";
const INIT_ORDER_DIRECTION = 1


const ModelList = () => {

    // Log report for the page
    useLogReport('CAM LIST');


    const history = useHistory()

    const [currentPage, setCurrentPage] = useState(+sessionStorage.getItem("modelPage") || INIT_PAGE);
    const [modelOrder, setModelOrder] = useState(sessionStorage.getItem("modelOrder") || INIT_ORDER);
    const [orderDirection, setOrderDirection] = useState(+sessionStorage.getItem("modelorderDirection") || INIT_ORDER_DIRECTION);

    // Settting the filter for the model data
    const [modelFilter, setModelFilter] = useState(sessionStorage.getItem("modelApplyfilter") || `sensor.excludeFromUI = 0`);
    const [prevFilter, setPrevFilter] = useState(modelFilter);

    // Filter Modal
    const [open, setOpen] = useState(false);
    const handleFilterModalClose = () => {
        setOpen(false);
    }

    // Handling the model filter change
    const handleModelFilterChange = (appliedFilter, filterFormValues) => {
        console.log('Applied Filter:', appliedFilter);
        if (appliedFilter) {
            sessionStorage.setItem('modelApplyfilter', appliedFilter);
            sessionStorage.setItem('modelFilterValues', JSON.stringify(filterFormValues));
        } else {
            sessionStorage.removeItem('modelApplyfilter');
            sessionStorage.removeItem('modelFilterValues');
        }
        setModelFilter(appliedFilter);
    }

    //Clearing the model filter
    const clearModelFilter = () => {
        sessionStorage.removeItem('modelApplyfilter');
        sessionStorage.removeItem('modelFilterValues');
        setModelFilter(``);
    }

    useEffect(() => {
        if (prevFilter !== modelFilter) {
            setCurrentPage(INIT_PAGE);
            sessionStorage.removeItem('modelPage');
        }
        setPrevFilter(modelFilter);
    }, [modelFilter]);

    const handleOrderChange = (sortBy, direction) => {
        setModelOrder(sortBy);
        sessionStorage.setItem('modelOrder', sortBy);

        setOrderDirection(+direction);
        sessionStorage.setItem('modelorderDirection', +direction);
    }

    const handleCurrentPageChange = (current) => {
        sessionStorage.setItem('modelPage', current)
        setCurrentPage(current);
    }

    const orderString = orderDirection === 1 ? `descending(${modelOrder}, true)` : `ascending(${modelOrder}, false)`;


    const { modelList, loading } = useGetModelList(modelFilter)


    /** @type import('@tanstack/react-table').ColumnDef<any> */
    const columns = [
        // {
        //     header: 'Model ID',
        //     accessorFn: (row) => row?.id,
        //     id: 'id',
        // },
        {
            header: 'Model Name',
            accessorFn: (row) => row?.name,
            id: 'name',
        },
        {
            header: 'Created Date',
            accessorFn: (row) => (row.created_ts && splitToArray(row.created_ts)[0]),
            id: 'createdDate',
        },
        // {
        //     header: 'Model Type',
        //     accessorFn: (row) => row?.model_type,
        //     id: 'model_type',
        // },
        // {
        //     header: 'Train Status',
        //     accessorFn: (row) => row?.training_status,
        //     id: 'training_status',
        // },
        {
            header: 'Status',
            accessorFn: (row) => {
                const status = row?.status?.[0];
                return status ? [status.name, status.count] : ['', 0];
            },
            sortingFn: (rowA, rowB, columnId) => {
                const [nameA, countA] = rowA.getValue(columnId) || ['', 0];
                const [nameB, countB] = rowB.getValue(columnId) || ['', 0];
                if (nameA < nameB) return -1;
                if (nameA > nameB) return 1;
                // If names are equal, compare counts numerically
                return Number(countA) - Number(countB);
            },
            cell: (props) => {
                const row = props.row.original;


                return row?.status && row?.status.map((status) => (

                    <div className='model-status-tag-container' key={status.name}>
                        <Tag
                            key={status.name}
                            sentiment={modelStatusSentimentMap[status.name]}
                            variant='outlined'
                            size='small'
                            shape='round'
                        >
                            <span className='status-count'>{status.count}</span>
                            {status.name}
                        </Tag>
                    </div>
                )
                )
            },
            id: 'status',
        },
        {
            header: 'Features',
            accessorFn: (row) => row?.features.join(', '),
            cell: (props) => {
                const row = props.row.original;
                const features = row?.features.join(', ');
                return features?.length > 10 ? <Tooltip placement='bottom'
                    overlay={<div className='tooltip-content'>{features}</div>}
                    trigger={<Button className='table-tooltip' style={{ padding: "0px" }} variant='transparent' onClick={() => { }}>{features?.substring(0, 10)}...</Button>} />
                    : features
            },
            id: 'features',
        },
        // {
        //     header: 'Target',
        //     accessorFn: (row) => row?.target,
        //     id: 'target',
        // },
        {
            header: 'Train Start Date',
            accessorFn: (row) => row.train_start_ts && splitToArray(row.train_start_ts)[0],
            id: 'train_start_ts',
        },
        {
            header: 'Train End Date',
            accessorFn: (row) => row.train_end_ts && splitToArray(row.train_end_ts)[0],
            id: 'train_end_ts',
        },
        {
            header: '',
            cell: (props) => {
                const row = props.row.original;
                return (
                    <Tooltip overlay={<span>Train Model</span>}
                        placement='bottom'
                        trigger={<Button
                            variant="outlined"
                            sentiment='positive'
                            iconOnly
                            icon={
                                <Play />
                            }
                            size='small'
                            onClick={(e) => {
                                e.stopPropagation();
                                history.push(`/models/create/${row?.id}`);
                            }}
                        />
                        }
                    />

                )
            },
            id: 'create',
        }
    ]

    return (
        <>
            <DocumentTitle title='CARMA - Models' />
            <div className='parent-container'>
                <div className='content-container'>
                    <div className='content-header cam-header'>
                        <div className='header-title'>
                            <h3>CARMA Autonomous Model</h3>
                            {/* <Text prominence='subtle' size='small' id='header-nav-id-5'>CARMA Autonomous Model</Text> */}

                        </div>
                    </div>
                    <div className='content-body'>
                        <div className='model-content-body-header'>
                            <h4>Model List</h4>
                            <div className='header-actions'>
                                <Tooltip overlay={<span>Filter Options</span>}
                                    placement='bottom'
                                    trigger={<Button iconOnly icon={<Filter />}
                                        onClick={() => setOpen(true)} 
                                        disabled={loading}
                                        />}
    
                                />
                            </div>
                        </div>
                        {loading && <div className='loading-container'> <Loading /> </div>}
                        {!loading && modelList && <DataTable data={modelList} columns={columns} count={modelList.length}
                            currentPage={+sessionStorage.getItem("modelPage") || INIT_PAGE}
                            handleCurrentPageChange={handleCurrentPageChange}
                            handleOrderChange={handleOrderChange}
                            INIT_ORDER={sessionStorage.getItem("modelOrder") || INIT_ORDER}
                            INIT_ORDER_DIRECTION={+sessionStorage.getItem("modelorderDirection") || INIT_ORDER_DIRECTION}
                            loading={loading}
                            paginationMode='client'
                            isModel={true}
                        />}

                    </div>
                </div>
            </div>
            <FilterModal open={open} onClose={handleFilterModalClose}
                handleFilterChange={handleModelFilterChange}
                handleFilterClear={clearModelFilter}
                filterKey='modelFilterValues'
                isModel={true}
        
            />
        </>
    )
}

export default ModelList